import { TsType, TS_SCREEN } from '../../types/common/CommonType';
import { ContactInputType } from '../../types/common/ContactType';
import { CustomerInformationInputType } from '../../types/common/CustomerInformationType';
import { InquiryApiRequest } from '../../types/api/InquiryApiType';
import { ContactLogic } from '../Contact/ContactLogic';
import { CustomerInformationLogic } from '../CustomerInformation/CustomerInformationLogic';
import { EditEstimateRowLogic } from '../EditEstimate/editEstimateRowLogic';
import { EstimateInquiry } from '../../types/common/EstimateInquiryType';

// バリデーション
const confirmationValidation = (
    screenTransition: TsType,
    estimateInquiry: EstimateInquiry,
    contactInput: ContactInputType,
    cIInput: CustomerInformationInputType,
    setContactInquireErrorMessage: (value: string) => void,
    setContactTextErrorMessage: (value: string) => void,
    setCiErrorMessages: (value: Array<string>) => void
) => {
    let estValidationResult: Array<string> = [];
    let contactValidationResult: Array<string> = [];
    let ciValidationResult: Array<string> = [];

    // エラーメッセージ初期化
    setContactInquireErrorMessage('');
    setContactTextErrorMessage('');
    setCiErrorMessages([]);

    // ErrorModal表示用のメッセージ
    const retErrorMessage: Array<string> = [];
    if (screenTransition === TS_SCREEN.EST) {
        // バリデーションチェック 見積り依頼
        estValidationResult = EditEstimateRowLogic.validateEstimation(estimateInquiry, false);

        if (estValidationResult.length > 0) {
            retErrorMessage.push(...estValidationResult);
        }
    }
    if (screenTransition === TS_SCREEN.CONTACT) {
        contactValidationResult = ContactLogic.requiredInputValidation(
            contactInput,
            setContactInquireErrorMessage,
            setContactTextErrorMessage
        );
        if (contactValidationResult.length > 0) {
            retErrorMessage.push(...contactValidationResult);
        }
    }

    ciValidationResult = CustomerInformationLogic.ciInputValidation(cIInput, setCiErrorMessages);
    if (ciValidationResult.length > 0) {
        const setMessages: Array<string> = [];
        // 重複メッセージは設定しない
        ciValidationResult.forEach((row) => {
            if (!retErrorMessage.includes(row)) {
                setMessages.push(row);
            }
        });
        retErrorMessage.push(...setMessages);
    }

    return retErrorMessage;
};

// 問い合わせ登録内容編集
const editInquiry = (
    screenTransition: TsType,
    cIInput: CustomerInformationInputType,
    contactInput: ContactInputType,
    inquiryEstimateId: string
) => {
    let sendInquiryData: InquiryApiRequest = {
        company: cIInput.company,
        division: cIInput.division,
        name: cIInput.name,
        kana: cIInput.kana,
        mail: cIInput.mail,
        phone: cIInput.phone ?? '',
        reason_id: Number(cIInput?.reasonId),
        reason_comment: cIInput.reasonComment ?? '',
    };

    // 問い合わせ種別 設定値が無ければ項目も設定しない。
    const inquireTypeData =
        contactInput.checkedInquire.length > 0
            ? { inquire_type: contactInput.checkedInquire.flatMap((value) => Number(value)) }
            : undefined;
    // 機器リスト送付希望
    const deviceListRequestData = { device_list_request: contactInput.equipmentListRequest === true ? 1 : 0 };
    // お問い合わせ詳細 設定値が無ければ項目も設定しない。
    const reasonCommentData = contactInput.contactText.length > 0 ? { comment: contactInput.contactText } : undefined;
    // 問合せ見積ID
    const inquiryEstimateIdData = { inquiry_estimate_id: inquiryEstimateId };

    if (screenTransition === TS_SCREEN.EST) {
        // 見積依頼からの遷移の場合
        sendInquiryData = { ...sendInquiryData, ...inquiryEstimateIdData };
    } else {
        // 問合せからの遷移の場合
        sendInquiryData = { ...sendInquiryData, ...inquireTypeData, ...deviceListRequestData, ...reasonCommentData };
    }

    return sendInquiryData;
};

export const ConfirmationLogic = {
    confirmationValidation,
    editInquiry,
};
